import { BaseSearchDTO } from "../../../../../uinspect/src/app/global/interfaces";

export interface UInspectFormatSearchDTO extends BaseSearchDTO {
  filters?: {
    id: number,
    vehicleTypeId: number;
  };
}
